import React, { useEffect, useRef, useState } from 'react';
import './style.scss';
import '../style.scss';
import vietQr from "assets/imgs/QrCodeMyVNPT/vietQr.png";
import napas247 from "assets/imgs/QrCodeMyVNPT/napas247.png";
import vnptMomey from "assets/imgs/QrCodeMyVNPT/vnpt-momey.png";
import infoIcon from "assets/imgs/QrCodeMyVNPT/info-icon.png";
import downloadIcon from "assets/imgs/QrCodeMyVNPT/download-icon.png";
import bankIcon from "assets/imgs/QrCodeMyVNPT/bank-icon.png";
import qrBlurry from "assets/imgs/QrCodeMyVNPT/qr-blurry.jpg";
import { Modal } from 'antd';
import ChooseBankingApp from '../ChooseBankingApp/ChooseBankingApp';
import { QRCodeCanvas } from 'qrcode.react';
import { DEVICE } from '../constant/contanst';
import { cjmEventButtonClicked } from 'utils/providers/cjmHelper';

const PayQrCode = ({ setStep, isModal, onClick, qrData, qrBase64, device, listBanks }) => {
  const [isModalChooseBank, setIsModalChooseBank] = useState(false);
  const qrRef = useRef(null);
  const timerRef = useRef(null);
  const handleIOS = () => {
    setIsModalChooseBank(true);
    onClick();
  }

  const handleAndroid = () => {
    setIsModalChooseBank(true);
    cjmEventButtonClicked("myvnpt_web", "roaming_package_QR", "qr_download");
    onClick();
  }
  
  const handleDownload = () => {
    if (qrBase64) {
      const link = document.createElement("a");
      link.href = qrBase64;
      link.download = "qrcode.png";
      link.click();
    }
  };

  const startPress = () => {
    if(device === DEVICE.IOS) {
      timerRef.current = setTimeout(() => {
        console.log("hold image");
        cjmEventButtonClicked("myvnpt_web", "roaming_package_QR", "qr_code");
      }, 500);
    }
  };

  const cancelPress = () => {
    clearTimeout(timerRef.current);
  };

  return (
    <>
      <Modal
        className="qr-code__modal-custom"
        title={null}
        footer={null}
        closable={null}
        open={isModal}
      >
        <div className="qr-code-modal-pay-qr-code">
          <div className="pay-qr-code__frame">
            <div>
              <img className="img-vietQr" src={vietQr} alt="vietQr" />
            </div>
            <div className="pay-qr-code__img">
            {
              qrData
              ? (
                <>
                  <QRCodeCanvas size={148} value={qrData} style={{display: qrBase64 ? "none" : "block"}}/>
                  <img
                    onMouseDown={startPress}
                    onTouchStart={startPress}
                    onMouseUp={cancelPress}
                    onMouseLeave={cancelPress}
                    onTouchEnd={cancelPress}
                    src={qrBase64}
                    alt="QR Code"
                  /> 
                </>
              )
              : <img height={148} width={148} src={qrBlurry} alt="" />
            }
            </div>
            <div className="pay-qr-code__group-img">
              <img className="img-napas247" src={napas247} alt="" />
              <img className="img-vnpt-money" src={vnptMomey} alt="" />
            </div>
          </div>

          {
            (device === DEVICE.IOS || device === DEVICE.ANDROID) && (
            <>
              <div className="pay-qr-code__des">
                <img src={infoIcon} alt="" />
                <span>
                  {
                    device === DEVICE.ANDROID 
                    ? "Nhấn “Tải mã QR xuống” để bắt đầu thanh toán" 
                    : "Lưu mã QR xuống bằng cách nhấn giữ mã QR và nhấn “Lưu hình ảnh”, sau đó nhấn:"
                  }
                </span>
                <span></span>
              </div>
              { device === DEVICE.ANDROID
                ?
                  <a href={qrBase64} download className="qr-code__btn-custom" onClick={handleAndroid}>
                    <img src={downloadIcon} alt="" />
                    Tải mã QR xuống
                  </a>
                :
                  <button className="qr-code__btn-custom" onClick={handleIOS}>
                    <img src={bankIcon} alt="" />
                    Chọn ngân hàng thanh toán
                  </button>
              }
            </>
            )
          }
        </div>
      </Modal>
      <ChooseBankingApp
        isModal={isModalChooseBank}
        setIsModal={setIsModalChooseBank}
        onClick={() => {}} 
        setStep={setStep}
        device={device}
        listBanks={listBanks}
      />
    </>
  );
}

export default React.memo(PayQrCode);
